import type { AppraisalCycle, AppraisalTemplate, ActivityItem } from '@/store/appraisalStore';

// ── Cycles ──────────────────────────────────────────────────
export const MOCK_CYCLES: AppraisalCycle[] = [
  {
    id: 'cycle-001',
    name: 'Annual Performance Review 2025',
    description: 'Company-wide annual appraisal cycle for FY 2025',
    year: 2025,
    status: 'active',
    startDate: '2025-04-01',
    endDate: '2025-06-30',
    employeeWindowStart: '2025-04-01',
    employeeWindowEnd: '2025-04-30',
    managerWindowStart: '2025-05-01',
    managerWindowEnd: '2025-05-25',
    hrWindowStart: '2025-05-26',
    hrWindowEnd: '2025-06-15',
    totalAssigned: 312,
    submitted: 247,
    managerReviewed: 198,
    hrReviewed: 142,
    completed: 89,
    department: 'All Departments',
    scoringScale: 5,
    approvalLevels: 2,
    createdBy: 'Priya Nair',
    createdAt: '2025-03-10T09:00:00Z',
    updatedAt: '2025-05-11T14:22:00Z',
    templateId: 'tmpl-001',
    templateName: 'Standard Annual Review v3',
    autoCloseEnabled: true,
    freezeOnSubmit: false,
    sequentialApproval: true,
  },
  {
    id: 'cycle-002',
    name: 'Mid-Year Review Q2 2025',
    description: 'Half-yearly check-in for Engineering & Product teams',
    year: 2025,
    status: 'in-progress',
    startDate: '2025-03-15',
    endDate: '2025-05-31',
    employeeWindowStart: '2025-03-15',
    employeeWindowEnd: '2025-04-15',
    managerWindowStart: '2025-04-16',
    managerWindowEnd: '2025-05-10',
    hrWindowStart: '2025-05-11',
    hrWindowEnd: '2025-05-28',
    totalAssigned: 87,
    submitted: 81,
    managerReviewed: 64,
    hrReviewed: 41,
    completed: 28,
    department: 'Engineering, Product',
    scoringScale: 5,
    approvalLevels: 1,
    createdBy: 'Rahul Mehta',
    createdAt: '2025-02-28T11:00:00Z',
    updatedAt: '2025-05-10T08:45:00Z',
    templateId: 'tmpl-002',
    templateName: 'Engineering Mid-Year Template',
    autoCloseEnabled: false,
    freezeOnSubmit: true,
    sequentialApproval: false,
  },
  {
    id: 'cycle-003',
    name: 'Probation Review — March 2025 Batch',
    description: 'Probation appraisal for employees completing 6 months',
    year: 2025,
    status: 'hr-review',
    startDate: '2025-04-20',
    endDate: '2025-05-20',
    employeeWindowStart: '2025-04-20',
    employeeWindowEnd: '2025-04-30',
    managerWindowStart: '2025-05-01',
    managerWindowEnd: '2025-05-10',
    hrWindowStart: '2025-05-11',
    hrWindowEnd: '2025-05-20',
    totalAssigned: 23,
    submitted: 23,
    managerReviewed: 23,
    hrReviewed: 14,
    completed: 0,
    department: 'Sales, Operations',
    scoringScale: 4,
    approvalLevels: 2,
    createdBy: 'Ananya Sharma',
    createdAt: '2025-04-15T10:30:00Z',
    updatedAt: '2025-05-11T09:00:00Z',
    templateId: 'tmpl-003',
    templateName: 'Probation Assessment Form',
    autoCloseEnabled: true,
    freezeOnSubmit: true,
    sequentialApproval: true,
  },
  {
    id: 'cycle-004',
    name: 'Sales Team Q1 Incentive Review',
    description: 'Quarterly incentive-linked appraisal for sales force',
    year: 2025,
    status: 'completed',
    startDate: '2025-01-15',
    endDate: '2025-02-28',
    employeeWindowStart: '2025-01-15',
    employeeWindowEnd: '2025-01-31',
    managerWindowStart: '2025-02-01',
    managerWindowEnd: '2025-02-15',
    hrWindowStart: '2025-02-16',
    hrWindowEnd: '2025-02-25',
    totalAssigned: 54,
    submitted: 54,
    managerReviewed: 54,
    hrReviewed: 54,
    completed: 54,
    department: 'Sales',
    scoringScale: 5,
    approvalLevels: 2,
    createdBy: 'Priya Nair',
    createdAt: '2025-01-05T08:00:00Z',
    updatedAt: '2025-03-02T16:00:00Z',
    templateId: 'tmpl-004',
    templateName: 'Sales Incentive Appraisal',
    autoCloseEnabled: true,
    freezeOnSubmit: true,
    sequentialApproval: true,
  },
  {
    id: 'cycle-005',
    name: 'Leadership 360 Review FY25',
    description: 'Multi-rater 360-degree feedback for team leads and managers',
    year: 2025,
    status: 'published',
    startDate: '2025-05-20',
    endDate: '2025-07-15',
    employeeWindowStart: '2025-05-20',
    employeeWindowEnd: '2025-06-10',
    managerWindowStart: '2025-06-11',
    managerWindowEnd: '2025-06-30',
    hrWindowStart: '2025-07-01',
    hrWindowEnd: '2025-07-12',
    totalAssigned: 41,
    submitted: 0,
    managerReviewed: 0,
    hrReviewed: 0,
    completed: 0,
    department: 'All Departments',
    scoringScale: 5,
    approvalLevels: 3,
    createdBy: 'Vikram Iyer',
    createdAt: '2025-05-01T14:00:00Z',
    updatedAt: '2025-05-08T11:00:00Z',
    templateId: 'tmpl-005',
    templateName: '360 Leadership Feedback Form',
    autoCloseEnabled: false,
    freezeOnSubmit: false,
    sequentialApproval: true,
  },
  {
    id: 'cycle-006',
    name: 'Customer Support Annual FY25',
    description: 'Annual appraisal for customer support and CX teams',
    year: 2025,
    status: 'under-review',
    startDate: '2025-03-01',
    endDate: '2025-05-15',
    employeeWindowStart: '2025-03-01',
    employeeWindowEnd: '2025-03-31',
    managerWindowStart: '2025-04-01',
    managerWindowEnd: '2025-04-25',
    hrWindowStart: '2025-04-26',
    hrWindowEnd: '2025-05-12',
    totalAssigned: 68,
    submitted: 68,
    managerReviewed: 55,
    hrReviewed: 30,
    completed: 18,
    department: 'Customer Support',
    scoringScale: 5,
    approvalLevels: 2,
    createdBy: 'Ananya Sharma',
    createdAt: '2025-02-20T09:00:00Z',
    updatedAt: '2025-05-09T13:30:00Z',
    templateId: 'tmpl-001',
    templateName: 'Standard Annual Review v3',
    autoCloseEnabled: true,
    freezeOnSubmit: true,
    sequentialApproval: false,
  },
  {
    id: 'cycle-007',
    name: 'Annual Performance Review 2024',
    description: 'Company-wide annual appraisal cycle for FY 2024',
    year: 2024,
    status: 'archived',
    startDate: '2024-04-01',
    endDate: '2024-06-30',
    employeeWindowStart: '2024-04-01',
    employeeWindowEnd: '2024-04-30',
    managerWindowStart: '2024-05-01',
    managerWindowEnd: '2024-05-25',
    hrWindowStart: '2024-05-26',
    hrWindowEnd: '2024-06-15',
    totalAssigned: 289,
    submitted: 289,
    managerReviewed: 289,
    hrReviewed: 289,
    completed: 289,
    department: 'All Departments',
    scoringScale: 5,
    approvalLevels: 2,
    createdBy: 'Priya Nair',
    createdAt: '2024-03-10T09:00:00Z',
    updatedAt: '2024-07-05T12:00:00Z',
    templateId: 'tmpl-001',
    templateName: 'Standard Annual Review v2',
    autoCloseEnabled: true,
    freezeOnSubmit: true,
    sequentialApproval: true,
  },
  {
    id: 'cycle-008',
    name: 'Finance Team Half-Year FY25',
    description: 'Half-year review for Finance and Accounts teams',
    year: 2025,
    status: 'draft',
    startDate: '2025-06-01',
    endDate: '2025-07-31',
    employeeWindowStart: '2025-06-01',
    employeeWindowEnd: '2025-06-20',
    managerWindowStart: '2025-06-21',
    managerWindowEnd: '2025-07-10',
    hrWindowStart: '2025-07-11',
    hrWindowEnd: '2025-07-28',
    totalAssigned: 0,
    submitted: 0,
    managerReviewed: 0,
    hrReviewed: 0,
    completed: 0,
    department: 'Finance',
    scoringScale: 5,
    approvalLevels: 2,
    createdBy: 'Rahul Mehta',
    createdAt: '2025-05-12T07:30:00Z',
    updatedAt: '2025-05-12T07:30:00Z',
    templateId: 'tmpl-002',
    templateName: 'Engineering Mid-Year Template',
    autoCloseEnabled: false,
    freezeOnSubmit: false,
    sequentialApproval: true,
  },
];

// ── Templates ──────────────────────────────────────────────
export const MOCK_TEMPLATES: AppraisalTemplate[] = [
  {
    id: 'tmpl-001',
    name: 'Standard Annual Review v3',
    description: 'Comprehensive annual performance review with KPI, competency, and goal sections',
    version: 'v3.2',
    status: 'active',
    usedInCycles: 4,
    createdBy: 'Priya Nair',
    createdAt: '2024-12-01T09:00:00Z',
    updatedAt: '2025-03-15T10:00:00Z',
    sections: [
      {
        id: 'sec-001',
        name: 'Goal Achievement',
        description: 'Review of goals set at the beginning of the cycle',
        order: 1,
        weightage: 40,
        questions: [
          {
            id: 'q-001',
            text: 'Rate your overall goal achievement for this review period',
            type: 'rating',
            required: true,
            weightage: 20,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-001',
            order: 1,
          },
          {
            id: 'q-002',
            text: 'Describe the key goals you achieved and the impact created',
            type: 'textarea',
            required: true,
            weightage: 15,
            maxChars: 1000,
            sectionId: 'sec-001',
            order: 2,
          },
          {
            id: 'q-003',
            text: 'List goals that were not fully achieved and the reasons',
            type: 'goal',
            required: false,
            weightage: 5,
            sectionId: 'sec-001',
            order: 3,
          },
        ],
      },
      {
        id: 'sec-002',
        name: 'KPI Performance',
        description: 'Quantitative KPI metrics assessment',
        order: 2,
        weightage: 30,
        questions: [
          {
            id: 'q-004',
            text: 'Select your overall KPI achievement band for this period',
            type: 'single-select',
            required: true,
            weightage: 15,
            options: ['Below 60%', '60%–80%', '80%–100%', 'Above 100%'],
            sectionId: 'sec-002',
            order: 1,
          },
          {
            id: 'q-005',
            text: 'Rate your performance against each KPI assigned to you',
            type: 'kpi',
            required: true,
            weightage: 15,
            sectionId: 'sec-002',
            order: 2,
          },
        ],
      },
      {
        id: 'sec-003',
        name: 'Competency Assessment',
        description: 'Behavioral and leadership competencies',
        order: 3,
        weightage: 20,
        questions: [
          {
            id: 'q-006',
            text: 'Rate your communication and collaboration skills',
            type: 'competency',
            required: true,
            weightage: 10,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-003',
            order: 1,
          },
          {
            id: 'q-007',
            text: 'Rate your problem-solving and decision-making ability',
            type: 'competency',
            required: true,
            weightage: 10,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-003',
            order: 2,
          },
        ],
      },
      {
        id: 'sec-004',
        name: 'Development & Career',
        description: 'Training, growth, and future development plans',
        order: 4,
        weightage: 10,
        questions: [
          {
            id: 'q-008',
            text: 'What training or certifications did you complete this year?',
            type: 'textarea',
            required: false,
            weightage: 5,
            maxChars: 500,
            sectionId: 'sec-004',
            order: 1,
          },
          {
            id: 'q-009',
            text: 'Select your preferred development focus for the next cycle',
            type: 'multi-select',
            required: false,
            weightage: 5,
            options: [
              'Technical Skills',
              'Leadership',
              'Communication',
              'Domain Expertise',
              'Cross-functional',
            ],
            sectionId: 'sec-004',
            order: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'tmpl-002',
    name: 'Engineering Mid-Year Template',
    description:
      'Focused mid-year review for engineering teams with tech delivery and code quality metrics',
    version: 'v2.0',
    status: 'active',
    usedInCycles: 2,
    createdBy: 'Rahul Mehta',
    createdAt: '2024-09-10T11:00:00Z',
    updatedAt: '2025-02-20T09:00:00Z',
    sections: [
      {
        id: 'sec-005',
        name: 'Technical Delivery',
        description: 'Sprint velocity, delivery quality, and technical contributions',
        order: 1,
        weightage: 50,
        questions: [
          {
            id: 'q-010',
            text: 'Rate your technical delivery quality over this period',
            type: 'rating',
            required: true,
            weightage: 25,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-005',
            order: 1,
          },
          {
            id: 'q-011',
            text: 'Describe your most impactful technical contribution',
            type: 'textarea',
            required: true,
            weightage: 25,
            maxChars: 800,
            sectionId: 'sec-005',
            order: 2,
          },
        ],
      },
      {
        id: 'sec-006',
        name: 'Team Collaboration',
        description: 'Code reviews, knowledge sharing, and team support',
        order: 2,
        weightage: 30,
        questions: [
          {
            id: 'q-012',
            text: 'How many code reviews did you actively participate in?',
            type: 'single-select',
            required: true,
            weightage: 15,
            options: ['0–5', '6–15', '16–30', '30+'],
            sectionId: 'sec-006',
            order: 1,
          },
          {
            id: 'q-013',
            text: 'Rate your knowledge-sharing contributions to the team',
            type: 'rating',
            required: true,
            weightage: 15,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-006',
            order: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'tmpl-003',
    name: 'Probation Assessment Form',
    description:
      'Structured 6-month probation evaluation covering role fit, skill gap, and cultural alignment',
    version: 'v1.4',
    status: 'active',
    usedInCycles: 3,
    createdBy: 'Ananya Sharma',
    createdAt: '2024-06-01T10:00:00Z',
    updatedAt: '2025-01-10T08:00:00Z',
    sections: [
      {
        id: 'sec-007',
        name: 'Role Fitment',
        description: 'Assessment of job role competency and skill match',
        order: 1,
        weightage: 60,
        questions: [
          {
            id: 'q-014',
            text: 'Rate your understanding of your job responsibilities',
            type: 'rating',
            required: true,
            weightage: 30,
            minRating: 1,
            maxRating: 4,
            sectionId: 'sec-007',
            order: 1,
          },
          {
            id: 'q-015',
            text: 'Describe challenges faced in your role and how you overcame them',
            type: 'textarea',
            required: true,
            weightage: 30,
            maxChars: 600,
            sectionId: 'sec-007',
            order: 2,
          },
        ],
      },
      {
        id: 'sec-008',
        name: 'Cultural Alignment',
        description: 'Values, behavior, and team integration assessment',
        order: 2,
        weightage: 40,
        questions: [
          {
            id: 'q-016',
            text: 'Select values you feel you have demonstrated strongly',
            type: 'multi-select',
            required: true,
            weightage: 20,
            options: ['Ownership', 'Collaboration', 'Innovation', 'Customer Focus', 'Integrity'],
            sectionId: 'sec-008',
            order: 1,
          },
          {
            id: 'q-017',
            text: 'Rate your integration with the team and company culture',
            type: 'rating',
            required: true,
            weightage: 20,
            minRating: 1,
            maxRating: 4,
            sectionId: 'sec-008',
            order: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'tmpl-004',
    name: 'Sales Incentive Appraisal',
    description: 'Quarterly sales performance review with revenue targets and pipeline metrics',
    version: 'v2.1',
    status: 'active',
    usedInCycles: 5,
    createdBy: 'Priya Nair',
    createdAt: '2024-01-15T09:00:00Z',
    updatedAt: '2024-12-01T11:00:00Z',
    sections: [
      {
        id: 'sec-009',
        name: 'Revenue Performance',
        description: 'Quota attainment, pipeline health, and deal closure',
        order: 1,
        weightage: 70,
        questions: [
          {
            id: 'q-018',
            text: 'What percentage of your quarterly revenue target did you achieve?',
            type: 'single-select',
            required: true,
            weightage: 35,
            options: ['Below 70%', '70%–90%', '90%–110%', 'Above 110%'],
            sectionId: 'sec-009',
            order: 1,
          },
          {
            id: 'q-019',
            text: 'Rate your pipeline management and forecasting accuracy',
            type: 'rating',
            required: true,
            weightage: 35,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-009',
            order: 2,
          },
        ],
      },
    ],
  },
  {
    id: 'tmpl-005',
    name: '360 Leadership Feedback Form',
    description: 'Multi-rater 360-degree feedback for team leads and senior managers',
    version: 'v1.0',
    status: 'draft',
    usedInCycles: 1,
    createdBy: 'Vikram Iyer',
    createdAt: '2025-04-20T14:00:00Z',
    updatedAt: '2025-05-01T10:00:00Z',
    sections: [
      {
        id: 'sec-010',
        name: 'Leadership Qualities',
        description: 'Vision, direction-setting, and people management',
        order: 1,
        weightage: 50,
        questions: [
          {
            id: 'q-020',
            text: "Rate the leader's ability to set clear direction and goals",
            type: 'rating',
            required: true,
            weightage: 25,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-010',
            order: 1,
          },
          {
            id: 'q-021',
            text: "Rate the leader's effectiveness in developing team members",
            type: 'rating',
            required: true,
            weightage: 25,
            minRating: 1,
            maxRating: 5,
            sectionId: 'sec-010',
            order: 2,
          },
        ],
      },
    ],
  },
];

// ── Activities ──────────────────────────────────────────────
export const MOCK_ACTIVITIES: ActivityItem[] = [
  {
    id: 'act-001',
    type: 'submit',
    actor: 'Deepak Nambiar',
    action: 'submitted appraisal form for',
    target: 'Annual Performance Review 2025',
    timestamp: '2025-05-12T04:40:00Z',
    cycleId: 'cycle-001',
  },
  {
    id: 'act-002',
    type: 'review',
    actor: 'Sanjay Kulkarni',
    action: 'completed manager review for',
    target: 'Probation Review — March 2025 Batch',
    timestamp: '2025-05-12T04:15:00Z',
    cycleId: 'cycle-003',
  },
  {
    id: 'act-003',
    type: 'overdue',
    actor: 'System',
    action: 'flagged 9 employees as overdue in',
    target: 'Mid-Year Review Q2 2025',
    timestamp: '2025-05-12T03:00:00Z',
    cycleId: 'cycle-002',
  },
  {
    id: 'act-004',
    type: 'approve',
    actor: 'Priya Nair',
    action: 'approved HR final review for',
    target: 'Sales Team Q1 Incentive Review',
    timestamp: '2025-05-11T18:30:00Z',
    cycleId: 'cycle-004',
  },
  {
    id: 'act-005',
    type: 'create',
    actor: 'Rahul Mehta',
    action: 'created new cycle',
    target: 'Finance Team Half-Year FY25',
    timestamp: '2025-05-11T14:00:00Z',
    cycleId: 'cycle-008',
  },
  {
    id: 'act-006',
    type: 'reject',
    actor: 'Ananya Sharma',
    action: 'sent back for revision in',
    target: 'Customer Support Annual FY25',
    timestamp: '2025-05-11T11:20:00Z',
    cycleId: 'cycle-006',
  },
  {
    id: 'act-007',
    type: 'submit',
    actor: 'Meera Pillai',
    action: 'submitted appraisal form for',
    target: 'Annual Performance Review 2025',
    timestamp: '2025-05-11T09:45:00Z',
    cycleId: 'cycle-001',
  },
  {
    id: 'act-008',
    type: 'close',
    actor: 'Vikram Iyer',
    action: 'published cycle',
    target: 'Leadership 360 Review FY25',
    timestamp: '2025-05-08T16:00:00Z',
    cycleId: 'cycle-005',
  },
];

// ── Chart data ──────────────────────────────────────────────
export const SUBMISSION_TREND = [
  { week: 'W1 Apr', submitted: 28, total: 312, rate: 9 },
  { week: 'W2 Apr', submitted: 74, total: 312, rate: 24 },
  { week: 'W3 Apr', submitted: 121, total: 312, rate: 39 },
  { week: 'W4 Apr', submitted: 168, total: 312, rate: 54 },
  { week: 'W1 May', submitted: 198, total: 312, rate: 63 },
  { week: 'W2 May', submitted: 247, total: 312, rate: 79 },
];

export const DEPT_COMPLETION = [
  { dept: 'Engineering', submitted: 92, total: 98, pct: 94 },
  { dept: 'Sales', submitted: 48, total: 54, pct: 89 },
  { dept: 'Product', submitted: 21, total: 24, pct: 88 },
  { dept: 'Customer Support', submitted: 58, total: 68, pct: 85 },
  { dept: 'Operations', submitted: 31, total: 40, pct: 78 },
  { dept: 'Finance', submitted: 22, total: 32, pct: 69 },
  { dept: 'HR', submitted: 9, total: 16, pct: 56 },
  { dept: 'Marketing', submitted: 14, total: 28, pct: 50 },
  { dept: 'Legal', submitted: 4, total: 10, pct: 40 },
];

export const RATING_DISTRIBUTION = [
  { name: 'Outstanding (5)', value: 38, color: '#16a34a' },
  { name: 'Exceeds Expectations (4)', value: 87, color: '#2563eb' },
  { name: 'Meets Expectations (3)', value: 112, color: '#7c3aed' },
  { name: 'Needs Improvement (2)', value: 29, color: '#d97706' },
  { name: 'Unsatisfactory (1)', value: 11, color: '#dc2626' },
];
